export default !process.env.VUE_APP_CLIENT_URL && process.env.NODE_ENV !== 'production'
